var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-5"},[_c('h2',{staticClass:"mb-5"},[_vm._v("Historie aplikovaných pravidel v Automatizaci Objednávek:")]),(_vm.getEshopModules.order_rules)?_c('v-data-table',{staticClass:"eshop-table",attrs:{"headers":_vm.headers,"items":_vm.getEshopModules.order_rules.history,"item-key":"","items-per-page":20,"footer-props":{
      'items-per-page-options': [30, -1],
      'items-per-page-text': 'Počet položek na stránku:'
    }},scopedSlots:_vm._u([{key:"item.datetime",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(new Date(item.datetime).toLocaleString())+" ")]}}],null,false,3440155791)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }